import React from "react";
import useOurWebsocket from "./NewSocket";
import { SocketContext } from "./SocketContext";

export default function SocketProvider({ children }) {
  const socketValues = useOurWebsocket();

  return (
    <SocketContext.Provider value={socketValues}>
      {children}
    </SocketContext.Provider>
  );
}
